"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /Users/eugenechoi/altitude/react-admin-panel/~/inline-style-prefixer/utils/getPrefixedValue.js
// module id = 18
// module chunks = 0